export type ReservationDayStatus = 'check_in' | 'check_out' | 'stay';

/**
 * Per-day check-in / check-out / stay status for a reservation or inquiry,
 * derived on the client from its stay dates.
 *
 * This used to be computed by the backend (calendar-view `reservation_status`),
 * but it is purely a rendering concern, so it now lives in the app. Inquiries no
 * longer receive it from the API (gotidy PR #8324 review), and the guest
 * reservation equivalent is being deprecated — this helper is the single source
 * of truth for both.
 *
 * @param row a parsed reservation/inquiry; its `period.startDate`/`period.endDate`
 *   are ISO `yyyy-MM-dd` strings (falls back to the top-level `startDate`/`endDate`)
 * @param isoDate the calendar cell date, `yyyy-MM-dd`
 * @returns the status for that day, or `null` when the row is not on that day
 */
export function getReservationDayStatus(row: any, isoDate: string): ReservationDayStatus | null {
  if (!isoDate) {
    return null;
  }
  const start = row?.period?.startDate ?? row?.startDate ?? null;
  const end = row?.period?.endDate ?? row?.endDate ?? null;
  if (isoDate === start) {
    return 'check_in';
  }
  if (isoDate === end) {
    return 'check_out';
  }
  if (start && end && start < isoDate && isoDate < end) {
    return 'stay';
  }
  return null;
}
